import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { CoreModule } from 'app/core/core.module';
import { AuditTemplateListComponent } from './component/audit-template-list/audit-template-list.component';
import { AuditTemplateDetailsComponent } from './component/audit-template-details/audit-template-details.component';
import { AuditTemplateAddComponent } from './component/audit-template-add/audit-template-add.component';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service'
import { AUDITTEMPLATE_ROUTES } from 'app/audit-template/audit-template.routing';
import { AuditTemplateModuleAddComponent } from './component/audit-template-module-add/audit-template-module-add.component';
import { AuditTemplateModulesComponent } from './component/audit-template-modules/audit-template-modules.component';
import { AuditTemplateModulesListComponent } from './component/audit-template-modules-list/audit-template-modules-list.component'

@NgModule({
    declarations: [
        AuditTemplateListComponent,
        AuditTemplateDetailsComponent,
        AuditTemplateAddComponent,
        AuditTemplateModuleAddComponent,
        AuditTemplateModulesComponent,
        AuditTemplateModulesListComponent
    ],
    imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(AUDITTEMPLATE_ROUTES)
    ],
    providers: [
        AuditTemplateService
    ]
})
export class AuditTemplateModule { }
